import React from 'react';
import { EditableInfo } from '@icoach/components';

const HundredTShirtSizeBox = ({ className, hundredTShirtSize, onEdit }) => {
    return (
        <EditableInfo label="百T尺寸" onEdit={onEdit} className={className}>
            {hundredTShirtSize || <span className={'font-color-4'}>未設定</span>}
        </EditableInfo>
    );
};

export default HundredTShirtSizeBox;
